import { createNewsletterUnsubscribeHandlers } from "@server/playdata-newsletter"
import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

const handlers = createNewsletterUnsubscribeHandlers()

export const Route = createFileRoute("/api/playdata/newsletter/unsubscribe")(
  serverRouteConfig({
    server: {
      handlers,
    },
  })
)
